import { render } from "./Reward.vue?vue&type=template&id=2bca65dd"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"
script.render = render

export default script